import React, { useState, useEffect, useRef } from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import Config from "../Config";
import axios from "axios";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import Loading from "react-loading";
import { Save_User, Save_Property, Select_Property, Save_Partners, Select_Partner, Select_Staff_Client, Save_Staff_Clients } from "../Redux/actions";
import { useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import { toast } from "react-toastify";
import { useMutation, useQuery } from "react-query";
import { hasPermission, PERMISSION_ROUTE_MAP } from "../helpers";
import {
  SubmitBtn,
  InputGroup,
  FieldWrapper,
  Label,
} from "../Components/Styles/InputStyles";
import { useTranslation } from "react-i18next";

const LoginRight = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showOtpInput, setShowOtpInput] = useState(false);
  const firstOtpRef = useRef(null);
  //const property = useSelector((state) => state.PropertyReducer.property);
  const InitialValue = {
    phone: "",
    otp: ["", "", "", "", "", ""],
  };

  useEffect(() => {
    if (showOtpInput && firstOtpRef.current) {
      firstOtpRef.current.focus();
    }
  }, [showOtpInput]);


  //------- Send OTP Request -------
  const requestOtp = async (phone) => {
    return await axios.post(
      `${Config.apiUrl}/client/login`,
      {
        mobile: phone,
        platform: 3,
      },
      null
    );
  };

  const onSuccess = (res) => {
    if (res?.data?.isSuccess === true) {
      setShowOtpInput(true);
    }
  };

  const onError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingOtp, mutate: postOtpRequest } = useMutation(
    requestOtp,
    {
      onSuccess: onSuccess,
      onError: onError,
    }
  );

  //------- Verify OTP Request -------
  const verifyOtp = async (values) => {
    const body = new FormData();
    body.append("mobile", values.phone);
    body.append("otp", values.otp.join(""));
    return await axios.post(
      `${Config.apiUrl}/client/otp/verify`,
      {
        mobile: values.phone,
        otp: values.otp.join(""),
      },
      null
    );
  };

  const onVerifySuccess = (res) => {
    if (res?.data?.isSuccess === true) {
      const expireAt = moment()
        .add(Config.sessionExpiredTime, "minutes")
        .valueOf();
      const token = res.data.token;

      const realData = {
        ...res.data.user, token, expireAt,
        permissions: res.data.user.permissions || 0,
      };
      propertyListing(token).then((propertyRes) => {
        if (propertyRes) {
          const properties = propertyRes?.data?.data || [];

          const totalTenantCount = properties.reduce(
            (total, prop) => total + (prop.tenantCount || 0),
            0
          );
          const totalOccupiedBedCount = properties.reduce(
            (total, prop) => total + (prop.occupiedBedCount || 0),
            0
          );
          const totalBedCount = properties.reduce(
            (total, prop) => total + (prop.bedCount || 0),
            0
          );

          const allProperty = {
            id: 0,
            name: "All Properties",
            gId: "KIPINN",
            type: 0,
            tenantPreference: 3,
            tenantCount: totalTenantCount,
            occupiedBedCount: totalOccupiedBedCount,
            bedCount: totalBedCount,
          };
          const propertiesWithAll = [allProperty, ...properties];

          const user = res.data.user;

          const dashboardRoles = [
            Config.STAFF_ROLES.ADMIN,
            Config.STAFF_ROLES.PARTNER,
            Config.STAFF_ROLES.FINANCEADMIN,
            Config.STAFF_ROLES.SALES_HEAD,
            Config.STAFF_ROLES.KITCHEN_MANAGER,
            Config.STAFF_ROLES.SALESPERSON,
            Config.STAFF_ROLES.IT_ADMIN,
            Config.STAFF_ROLES.WARDEN,
            Config.STAFF_ROLES.MAINTENANCE_SUPERVISOR,
          ];

          if (res.data.user.userType === Config.USER_TYPE.CLIENT) {
            dispatch(Save_Partners(res?.data?.personalAndPartnerProperties));
            dispatch(Select_Partner(res?.data?.personalAndPartnerProperties[0]));
          }
          else if (res.data.user.userType === Config.USER_TYPE.STAFF) {
            dispatch(Save_Staff_Clients(res?.data?.staffAccounts));
            dispatch(Select_Staff_Client(res?.data?.staffAccounts[0]));
          }
          dispatch(Save_Property(propertiesWithAll));
          dispatch(Select_Property(allProperty));
          dispatch(Save_User(realData));
          if (user.userType === Config.USER_TYPE.CLIENT || dashboardRoles.includes(user.role)) {
            navigate("/dashboard");
          } else if (user.userType === Config.USER_TYPE.LANDLORD) {
            navigate("/landlord/dashboard");
          }
          else {
            let finalRoute = "/property-list"; // default
            for (const item of PERMISSION_ROUTE_MAP) {
              if (hasPermission(item.permission, res.data.user)) {
                finalRoute = item.route;
                break;
              }
            }
            navigate(finalRoute);
          }
        }
      });
    }
  };

  const onVerifyError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: isLoadingVerify, mutate: postVerifyOtp } = useMutation(
    verifyOtp,
    {
      onSuccess: onVerifySuccess,
      onError: onVerifyError,
    }
  );

  const handleGetOtp = (phone) => {
    if (!phone) {
      return toast.error("Please enter a valid 10-digit mobile number.");
    }
    if (phone.length !== 10) {
      return toast.error("Please enter a valid 10-digit mobile number.");
    }
    postOtpRequest(phone);
  };

  const handleVerifyOtp = (values) => {
    if (values.otp.some((digit) => !digit)) {
      return toast.error("Please enter complete OTP");
    }
    postVerifyOtp(values);
  };

  const propertyListing = async (token) =>
    await axios.get(`${Config.apiUrl}/property/list/web/dropdown`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer" + " " + token,
      },
    });

  return (
    <Logins>
      <TextWrapperComp
        InitialValue={InitialValue}
        handleGetOtp={handleGetOtp}
        handleVerifyOtp={handleVerifyOtp}
        isLoadingOtp={isLoadingOtp}
        isLoadingVerify={isLoadingVerify}
        showOtpInput={showOtpInput}
        setShowOtpInput={setShowOtpInput}
        t={t}
        firstOtpRef={firstOtpRef}
      />
      <FooterSection>
        <img
          src={Images.FooterBg}
          alt="footer"
          className="w-full h-auto opacity-50"
        />
      </FooterSection>
    </Logins>
  );
};

const TextWrapperComp = ({
  InitialValue,
  handleGetOtp,
  handleVerifyOtp,
  isLoadingOtp,
  isLoadingVerify,
  showOtpInput,
  setShowOtpInput,
  t,
  firstOtpRef
}) => (
  <TextWrapper>
    <Container>
      <div>
        <Center>

          <div className="mb-4">
            <Logo src={Images.Login_Logo} alt="logo" />
            <Title>{"Please Login with your Mobile Number"}</Title>
          </div>
          <Formik
            initialValues={InitialValue}
            onSubmit={
              showOtpInput
                ? handleVerifyOtp
                : (values) => handleGetOtp(values.phone)
            }
          >
            {({ values, setFieldValue }) => (
              <Form className="w-full">
                <FormContainer>
                  <InputGroup>
                    <Label htmlFor="phone">{"Mobile Number"}</Label>
                    <FieldWrapper>
                      <Field
                        name="phone"
                        id="phone"
                        type="text"
                        inputMode="numeric"
                        maxLength={10}
                        autoComplete="off"
                        onChange={(e) => {
                          const newValue = e.target.value.replace(/[^0-9]/g, "");
                          setFieldValue("phone", newValue);

                          if (showOtpInput) {
                            setShowOtpInput(false);
                            setFieldValue("otp", ["", "", "", "", "", ""]);
                          }
                        }}
                      />
                    </FieldWrapper>
                    {showOtpInput && (
                      <div className="flex justify-end items-center max-w-sm space-x-2">
                        <div className="text-gray-500 text-xs md:text-sm lg:text-md">
                          Did not receive an OTP?
                        </div>
                        <button
                          type="button"
                          onClick={() => handleGetOtp(values.phone)}
                          className="text-blue-600 font-medium text-xs md:text-sm lg:text-md"
                          disabled={isLoadingOtp}
                        >
                          Resend OTP
                        </button>
                      </div>
                    )}
                  </InputGroup>

                  {showOtpInput && (
                    <InputGroup>
                      <Label htmlFor="otp">{"Enter OTP"}</Label>
                      <div className="flex space-x-2">
                        {[0, 1, 2, 3, 4, 5].map((index) => (
                          <input
                            key={index}
                            ref={index === 0 ? firstOtpRef : null}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            className="w-10 h-10 text-center border rounded"
                            value={values.otp[index]}
                            onChange={(e) => {
                              const inputValue = e.target.value.replace(
                                /[^0-9]/g,
                                ""
                              );
                              if (inputValue.length > 1) return;
                              const newOtp = [...values.otp];
                              newOtp[index] = inputValue;
                              setFieldValue("otp", newOtp);
                              if (e.target.value && index < 5) {
                                document
                                  .getElementById(`otp-${index + 1}`)
                                  .focus();
                              }
                            }}
                            onKeyDown={(e) => {
                              if (
                                e.key === "Backspace" &&
                                !values.otp[index] &&
                                index > 0
                              ) {
                                document
                                  .getElementById(`otp-${index - 1}`)
                                  .focus();
                              } else if (e.key === "ArrowLeft" && index > 0) {
                                document
                                  .getElementById(`otp-${index - 1}`)
                                  .focus();
                              } else if (e.key === "ArrowRight" && index < 5) {
                                document
                                  .getElementById(`otp-${index + 1}`)
                                  .focus();
                              }
                            }}
                            id={`otp-${index}`}
                          />
                        ))}
                      </div>
                    </InputGroup>
                  )}
                </FormContainer>
                <div className="mt-4 lg:mt-10 flex w-full">
                  <SubmitBtn
                    type="submit"
                    disabled={isLoadingOtp || isLoadingVerify}

                  >
                    {isLoadingOtp || isLoadingVerify ? (
                      <Loading
                        color="white"
                        width={20}
                        height={20}
                      // noPadding={true}
                      />
                    ) : showOtpInput ? (
                      "Verify & Login"
                    ) : (
                      "Continue"
                    )}
                  </SubmitBtn>
                </div>
              </Form>
            )}
          </Formik>
        </Center>
      </div>
      {/* BOTTOM (terms line) */}
      <div className="pb-6">
        <p className="text-xs text-gray-500 text-center max-w-full mx-auto leading-relaxed">
          By continuing, you agree to our{" "}
          <a
            href="https://kipinn.com/terms/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline whitespace-nowrap text-[#0078BD] font-medium hover:underline"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="https://kipinn.com/privacy/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline whitespace-nowrap text-[#0078BD] font-medium hover:underline"
          >
            Privacy Policy
          </a>.
        </p>
      </div>
    </Container>
  </TextWrapper>
);

const Container = tw.div`
  flex flex-col h-full w-full
  justify-center items-start 
  px-4 sm:px-6 md:px-8 lg:px-10
`;
//const FormContainer = tw.div`grid max-w-sm mt-8 w-full gap-5 sm:gap-6 md:gap-7 lg:gap-8`;
//const FormContainer = tw.div`grid max-w-sm mt-4 w-full gap-3 md:gap-2`;
const FormContainer = tw.div`grid max-w-sm mt-6 w-full gap-5`;
const Logins = tw.section`h-dvh flex bg-white justify-center items-center px-6 sm:px-10 md:px-12 lg:px-16 xl:px-20`;
//const Container = tw.div`flex flex-col h-full w-full justify-center items-start px-4 sm:px-6 md:px-8 lg:px-10`;
//const Logo = tw.img`w-20 h-20 object-contain mb-6 sm:w-24 sm:h-24 md:w-28 md:h-28`;
const Logo = tw.img`
  w-16 h-16 
  object-contain 
  mb-6
  sm:w-16 sm:h-16
  md:w-19 md:h-19
`;
const TextWrapper = tw.div`h-full relative sm:max-w-sm sm:text-lg md:w-full md:max-w-md md:text-xl lg:max-w-lg lg:text-base xl:max-w-xl xl:text-lg`;
//const Title = tw.h1`text-lg font-medium text-gray-800 tracking-wider md:text-xl`;
const Title = tw.h1`
  text-xl md:text-2xl
  font-medium
  text-gray-700
  mb-5
  leading-snug
`
const Center = tw.div`h-full w-full flex flex-col justify-center py-8 sm:py-10 md:py-12`;
const FooterSection = tw.div`lg:hidden md:block sm:block absolute bottom-0 left-0 w-full h-6`;

export default LoginRight;